import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Headstu from './Headstu';
import { faUsers, faClipboardList } from "@fortawesome/free-solid-svg-icons";
import axios from '../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import LearnImage from '../images/logopng.png'
import StudentFeedbackPage from './Studentfeedback';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';

import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  makeStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper
} from '@material-ui/core';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import { baseURLdyte, Password, Username, baseURLdyteMeeting, dyteRestHeader } from '../common';
import Meeting from '../StudentLogin/Meeting';
import { Link, useNavigate, Routes, Route } from 'react-router-dom';
import './Dashboard.css';
import { faVideo, faFileInvoice, faEdit, faBook } from '@fortawesome/free-solid-svg-icons';
import { decryptData, encryptData, removeBracketedText } from '../Axiosinstance';
import { faComments, faCertificate } from "@fortawesome/free-solid-svg-icons";
import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import dayjs from 'dayjs';

import ArialFont from '../fonts/ArialBold.ttf';
// import cate from '../images/Certificate.png'


const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '1200px',
    margin: '3% auto',
    padding: '20px',
  },

  card: {
    marginBottom: '16px',
    border: '1px solid #ccc',
  },
  cardImage: {
    height: '100px',
    width: '100%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  signatureCanvas: {
    width: 500,
    height: 300,
  },
}));

function extractNamesFromArray(arr) {
  return arr.map((item) => {
    const match = item.match(/^([^(]+)/);
    return match ? match[0].trim() : '';
  });
}

const Man = () => {
  const [batchId, setBatchId] = useState([]);
  const [studentId, setStudentId] = useState([]);
  const [registrationID, setRegistration] = useState([]);

  const [batchData, setBatchData] = useState([]);
  const [fetchedCourseData, setFetchedCourseData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [courseId, setCourseId] = useState([]);
  const classes = useStyles();

  const [checkingMeeting, setCheckingMeeting] = useState(false);
  const studentStatus = decryptData(localStorage.getItem('status'));
  const isAlumni = studentStatus === 'Alumni';


  const navigate = useNavigate();
  const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

  const extractId = (str) => {
    const match = str.match(/\((\d+)\)/);
    return match ? match[1] : '';
  };

  useEffect(() => {
    const fetchBatchIds = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`registrationadvances/student/${studentTeacherId}/registration-advances`);
        const batchData = response.data;
        console.log("Student ID from Registration:", batchData[0].student.id);
        console.log("Student Name:", batchData[0].student.name);
        console.log("Student Teacher ID:", studentTeacherId);

        const loggedInUserId = decryptData(localStorage.getItem('userId'));
        console.log("Logged In User ID:", loggedInUserId);
        setBatchId(batchData[0].batch.id);
        setStudentId(batchData[0].student.id)
        setRegistration(batchData[0].id);
        console.log("hida", batchData[0].id)
        setBatchData(batchData);
      } catch (error) {
        console.error('Error fetching batch data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (studentTeacherId) {
      fetchBatchIds();
    }
  }, [studentTeacherId]);




  const currentRemainingBalance = 0;
  const totalPaid = 0;
  const monthlyPaymentsInfo = [];
  const filteredPayments = monthlyPaymentsInfo.filter(payment => payment.remainingBalance !== 0);


  const courseNames = [];

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const courseDataPromises = courseNames.map(async (courseName) => {
          if (courseName !== '0') {
            const response = await axios.get(`course/${courseName}`);
            setCourseId(response.data.id);
            return response.data.url;
          } else {
            return null;
          }
        });

        const fetchedCourseData = await Promise.all(courseDataPromises);
        setFetchedCourseData(fetchedCourseData);
      } catch (error) {
        console.error('Error fetching course data:', error);
      }
    };

    if (courseNames.length > 0 && !fetchedCourseData.length) {
      fetchCourseData();
    }
  }, [courseNames, fetchedCourseData]);



  const extractMeetingId = (link) => {
    if (!link) return null;
    const match = link.match(/id=([a-z0-9-]+)/i);
    return match ? match[1] : null;
  };

  const addParticipantToMeeting = async (meetingId) => {
    try {
      const loggedInUserId = decryptData(localStorage.getItem('userId'));
      const userDetailsResponse = await axios.get(`home/user/${loggedInUserId}`);
      const userDetails = userDetailsResponse.data;
      console.log("User Details:", userDetails);
      console.log("Student ID Sent To Dyte:", userDetails.id);
      const studentTeacherId = decryptData(localStorage.getItem('studentteacherid'));

      const response = await axios.post(
        `${baseURLdyte}/meetings/${meetingId}/participants`,
        {
          name: userDetails.name || 'student',
          picture:
            userDetails.profile_Url ||
            'https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg',
          preset_name: 'group_call_participant',
          custom_participant_id: String(userDetails.id),
        },
        {
          headers: {
            Authorization: dyteRestHeader,
            'Content-Type': 'application/json',
          },
        }
      );

      const token = response.data?.data?.token;

      console.log("DYTE RESPONSE:", response.data);

      if (!token) {
        alert("❌ Token not received");
        return;
      }

      // ✅ Correct Dyte meeting URL
      const meetingUrl = `https://meet.dyte.io/${meetingId}?authToken=${token}`;
      window.open(meetingUrl, '_blank');

    } catch (error) {
      console.error('Error adding participant:', error);
    }
  };

  const [showAllDates, setShowAllDates] = useState(false);


  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackBatchCtx, setFeedbackBatchCtx] = useState({
    batchId: null,
    intakeId: null
  });

  // ✅ FIXED isMeetingLive function
  // OLD: GET /sessions?meeting_id=xxx  → causes 422
  // NEW: GET /meetings/{meetingId}/sessions → correct Dyte v2 endpoint
  const isMeetingLive = async (meetingId) => {
    try {
      // ✅ Correct endpoint — meeting ID as path parameter
      const res = await axios.get(
        `${baseURLdyte}/meetings/${meetingId}/sessions`,
        {
          headers: {
            Authorization: dyteRestHeader, // ✅ use dyteRestHeader directly
            'Content-Type': 'application/json',
          },
        }
      );

      // Dyte v2 response shape: { success: true, data: [...] } or { data: { sessions: [...] } }
      const rawData = res.data?.data;

      // Handle both array and object response shapes safely
      const sessionList = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.sessions)
          ? rawData.sessions
          : [];

      if (!sessionList || sessionList.length === 0) {
        return false; // No sessions ever started for this meeting
      }

      // ✅ Correct field: total_participants (NOT live_participants which doesn't exist)
      const liveSession = sessionList.find(
        (s) =>
          s.started_at &&          // session has started
          !s.ended_at &&           // session has NOT ended
          s.total_participants > 0 // at least one participant (trainer) is in
      );

      return !!liveSession;

    } catch (err) {
      console.error('Error checking live session:', err);
      // Return false so the toast shows — meeting cannot be confirmed as live
      return false;
    }
  };


  const handleShowDialog = (index) => {
    setSelectedIndex(index);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedIndex(null);
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseDialog();
    }
  };






  return (

    <Routes>
      <Route path="/meeting/:meetingId" element={<Meeting />} />
      <Route
        path="/"
        element={
          isLoading ? (
            <Loader />
          ) : (
            <div>
              <Headstu batch={batchId} studentId={studentId} registrationID={registrationID} />
              <ToastContainer position="bottom-right" />

              <div className="containerd" style={{ textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
                <h1 className="welcome-heading fangsong" style={{ color: '#097969', fontSize: '2.8rem', textTransform: 'uppercase', letterSpacing: '0.1rem' }}>
                  <span style={{ fontFamily: 'Courier New, Courier, monospace', letterSpacing: '0.1rem', color: '#008eed' }}>
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', color: '#008eed' }}>A</span>llians
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', color: '#008eed' }}> I</span>nternational
                    <span style={{ fontSize: '3.0rem', fontWeight: 'bolder', color: '#008eed' }}> I</span>nstitute
                  </span>
                </h1>
                <h4 style={{ color: '#97903F', fontSize: '2.4rem', fontWeight: 'bold' }}>Learning Management System</h4>
              </div>

              <Container
                maxWidth="xl"
                style={{
                  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${LearnImage})`,
                  backgroundSize: '50%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center 10px',
                  minHeight: '60vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Grid container spacing={4} justifyContent="center">
                  {batchData.map((batch, index) => {
                    const schedule = batch.scheduleDate || [];
                    const lastEndDate = schedule.length > 0 ? schedule[schedule.length - 1].endDate : null;
                    const isCompleted = lastEndDate ? dayjs(lastEndDate).isBefore(dayjs()) : false;

                    // const menuItems = isCompleted
                    //   ? [
                    //     {
                    //       icon: faComments,
                    //       text: 'Feedbacks',
                    //       link: `/student-feedback/${studentTeacherId}`,
                    //     },
                    //     // {
                    //     //   icon: faCertificate,
                    //     //   text: 'Certificate',
                    //     //   action: () => handleCertificateDownload(batch),
                    //     // },
                    //   ]
                    //   : [
                    //     {
                    //       icon: faVideo,
                    //       text: 'Join Meeting',
                    //       action: () => {
                    //         const meetingId = extractMeetingId(batch?.batch?.onlineclasslink);
                    //         if (meetingId) {
                    //           addParticipantToMeeting(meetingId);
                    //         } else {
                    //           console.error('Meeting ID not found.');
                    //         }
                    //       },
                    //     },
                    //     {
                    //       icon: faEdit,
                    //       text: 'PDF Assessment',
                    //       link: `/PDFwritten/${encodeURIComponent(encryptData(batch?.batch?.id))}/${encodeURIComponent(encryptData(batch?.intakeId))}`,
                    //     },
                    //     {
                    //       icon: faBook,
                    //       text: 'Course Content',
                    //       link: `/content/${encodeURIComponent(encryptData(batch?.batch?.id))}`,
                    //     },
                    //     {
                    //       icon: faFileInvoice,
                    //       text: 'Payment Receipt',
                    //       link: `/Paymentview`,
                    //     },
                    //   ];


                    const menuItems = isAlumni
                      ? [
                        {
                          icon: faCommentDots,
                          text: 'Feedback',
                          action: () => {
                            setFeedbackBatchCtx({ batchId: batch?.batch?.id, intakeId: batch?.intakeId });
                            setShowFeedback(true);
                          },
                        },
                        // {
                        //   icon: faCertificate,
                        //   text: 'Certificate',
                        //   action: () => handleCertificateDownload(batch),
                        // },
                        {
                          icon: faBook,
                          text: 'Course Content',
                          link: `/content/${encodeURIComponent(encryptData(batch?.batch?.id))}`,
                        },
                        {
                          icon: faEdit,
                          text: 'PDF Assessment',
                          link: `/PDFwritten/${encodeURIComponent(encryptData(batch?.batch?.id))}/${encodeURIComponent(encryptData(batch?.intakeId))}`,
                        },
                        {
                          icon: faFileInvoice,
                          text: 'Payment Receipt',
                          link: `/Paymentview`,
                        },
                      ]
                      : [
                        {
                          icon: faCommentDots,
                          text: 'Feedback',
                          action: () => {
                            setFeedbackBatchCtx({ batchId: batch?.batch?.id, intakeId: batch?.intakeId });
                            setShowFeedback(true);
                          },
                        },
                        ...(isCompleted
                          ? [
                            // {
                            //   icon: faCertificate,
                            //   text: 'Certificate',
                            //   action: () => handleCertificateDownload(batch),
                            // },
                          ]
                          : [
                            {
                              icon: faVideo,
                              // ✅ Button text reflects checking state
                              text: checkingMeeting ? 'Checking...' : 'Join Meeting',
                              action: async () => {
                                const meetingId = extractMeetingId(batch?.batch?.onlineclasslink);
                                if (!meetingId) {
                                  toast.error('Meeting link not found.');
                                  return;
                                }

                                setCheckingMeeting(true);
                                const live = await isMeetingLive(meetingId); // ✅ now uses fixed function
                                setCheckingMeeting(false);

                                if (!live) {
                                  // ✅ Toast only shows when genuinely not live
                                  toast.warning('The meeting has not started yet. Please wait for your trainer.');
                                  return;
                                }

                                addParticipantToMeeting(meetingId);
                              },
                            },
                            {
                              icon: faEdit,
                              text: 'PDF Assessment',
                              link: `/PDFwritten/${encodeURIComponent(encryptData(batch?.batch?.id))}/${encodeURIComponent(encryptData(batch?.intakeId))}`,
                            },
                            {
                              icon: faBook,
                              text: 'Course Content',
                              link: `/content/${encodeURIComponent(encryptData(batch?.batch?.id))}`,
                            },
                            {
                              icon: faFileInvoice,
                              text: 'Payment Receipt',
                              link: `/Paymentview`,
                            },
                          ]),
                      ];

                    return (
                      <Grid item xs={12} md={10} key={index}>
                        {/* Main Course Card */}
                        <Card
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '30px',
                            boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)',
                            transition: 'transform 0.3s ease-in-out',
                            borderRadius: '25px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.02)';
                            e.currentTarget.style.backgroundColor = '#6DD5FA';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                          }}
                        >
                          <div style={{ flex: 1, textAlign: 'center' }}>
                            <img
                              src={batch.batch.courseImage}
                              alt="Course cover"
                              style={{
                                width: '100%',
                                maxHeight: '200px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                              }}
                            />
                          </div>

                          <CardContent
                            style={{
                              flex: 2,
                              textAlign: 'left',
                              padding: '20px',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px',
                            }}
                          >
                            <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1565C0' }}>
                              {batch.batch.course.split('(')[0]}
                            </Typography>

                            <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
                              <strong>Intake ID:</strong> {batch.intakeId}
                            </Typography>

                            <Typography variant="h6" style={{ fontWeight: '600', color: '#333' }}>
                              <strong>Trainer:</strong> {removeBracketedText(batch.batch.trainers.join(', '))}
                            </Typography>
                          </CardContent>
                        </Card>

                        {/* Action Menu Items */}
                        <Grid container spacing={2} justifyContent="center" style={{ marginTop: '20px' }}>
                          {menuItems.map((item, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Card
                                onClick={() => {
                                  if (item.action) {
                                    item.action();
                                  } else if (item.link) {
                                    navigate(item.link);
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  padding: '15px',
                                  transition: 'transform 0.3s ease-in-out',
                                  boxShadow: '0px 3px 6px rgba(0,0,0,0.11)',
                                  borderRadius: '15px',
                                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                  minHeight: '80px',
                                  cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'scale(1.02)';
                                  e.currentTarget.style.backgroundColor = '#6DD5FA';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                                }}
                              >
                                <CardContent
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '1.7rem',
                                      textAlign: 'center',
                                      flexGrow: 1,
                                    }}
                                  >
                                    {item.text}
                                  </Typography>

                                  <FontAwesomeIcon
                                    icon={item.icon}
                                    size="1.5x"
                                    style={{
                                      backgroundColor: '#E3F2FD',
                                      color: '#1976D2',
                                      borderRadius: '50%',
                                      padding: '15px',
                                      width: '60px',
                                      height: '60px',
                                      marginLeft: 'auto',
                                    }}
                                  />
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>

              </Container>


              {showFeedback && (
                <div
                  style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 1400,
                    background: 'rgba(0,0,0,0.35)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                  onClick={(e) => {
                    if (e.target === e.currentTarget) setShowFeedback(false);
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      maxWidth: 720,
                      background: '#F7F6F3',
                      overflowY: 'auto',
                    }}
                  >
                    <StudentFeedbackPage
                      batchId={feedbackBatchCtx.batchId}
                      intakeId={feedbackBatchCtx.intakeId}
                      studentId={studentId}
                      onClose={() => setShowFeedback(false)}
                    />
                  </div>
                </div>
              )}

            </div>
          )
        }
      />
    </Routes>

  );
};

export default Man;
